import { useDisclosure } from "@/hooks";
import { useCreateContact } from "@/hooks/query-hooks/useContacts";
import { Button, Form, Modal } from "antd";
import dayjs from "dayjs";
import { AiOutlinePlus } from "react-icons/ai";
import { ContactForm } from "./ContactForm";
import { DATE_FORMATS } from "@/constants";
import { createContactRequestSchema } from "@/constants/zod-schemas";

export function AddNewContactModal() {

    const [form] = Form.useForm();

    const [opened, { toggle }] = useDisclosure(false);

    const { mutate, isLoading } = useCreateContact();

    const onFinish = (values: CreateContactRequest) => {
        const { pickUpDate, pickUpTime, ...rest } = values;
        const data = {
            ...rest,
            pickUpDate: dayjs(pickUpDate).format(DATE_FORMATS.REQUEST_DATE_FORMAT),
            pickUpTime: dayjs(pickUpTime).format(DATE_FORMATS.REQUEST_TIME_FORMAT),
        };

        const payload = createContactRequestSchema.parse(data);

        mutate(payload, {
            onSuccess: () => {
                onModalClose();
            },
        });
    };

    const onModalClose = () => {
        form.resetFields();
        toggle();
    }

    return (
        <>
            <Button
                icon={<AiOutlinePlus />}
                onClick={toggle}
                type="primary"
                shape="circle"
                size="large"
                className="bg-primary-gradient"
            />
            <Modal
                open={opened}
                title="အဆက်အသွယ်ထည့်ရန်"
                onCancel={onModalClose}
                okText="အတည်ပြုမည်"
                cancelText="ပယ်ဖျက်မည်"
                okButtonProps={{
                    form: "add-new-contact-form",
                    htmlType: "submit",
                    type: "primary",
                    size: "large",
                    className: "bg-primary-gradient",
                    shape: "round",
                    loading: isLoading,
                }}
                cancelButtonProps={{
                    type: "text",
                    size: "large",
                    style: {
                        background: "transparent",
                    },
                    disabled: isLoading,
                }}
                width={640}
                maskClosable={!isLoading}
            >
                <ContactForm
                    initialValues={{}}
                    onFinish={onFinish}
                    form={form}
                    name="add-new-contact-form"
                />
            </Modal>
        </>
    )
}
